module.exports = __webpack_public_path__ + "img/17.feed5e98.png";